export default {
  title: 'Notifiche delle prenotazioni',
  label: 'Dove dobbiamo inviare le notifiche delle prenotazioni?',
  placeholder: 'es. prenotazioni@iltuoristorante.it',
  helper:
    'Va bene qualsiasi indirizzo e-mail: non serve un accesso alla dashboard. Puoi modificarlo o aggiungerne altri in seguito in Prenotazioni → Impostazioni → Notifiche e conferma.',
  errors: {
    required: 'Aggiungi un indirizzo e-mail per ricevere le notifiche delle prenotazioni.',
    invalid: 'Inserisci un indirizzo e-mail valido, come nome@ristorante.it.',
  },
};
